<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 手机端独立
    let htmlwidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    // 获取html的dom
    let htmldom = document.getElementsByTagName("html")[0];
    //设置html的font-size
    htmldom.style.fontSize = (20 / 375) * htmlwidth + "px";
    window.addEventListener("resize", (e) => {
      let htmlwidth = document.documentElement.clientWidth || document.body.clientWidth;
      htmldom.style.fontSize = (20 / 375) * htmlwidth + "px";
    });
  },
  methods: {},
};
</script>

<style>
@import "./assets/css/base.scss";
* {
  margin: 0;
  padding: 0;
  list-style: none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}
a {
  color: #666;
}
a:link,
a:hover,
a:active {
  color: #666;
  text-decoration: none;
}
img {
  border: 0;
}
ul,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
dl,
dt,
dd {
  margin: 0;
  padding: 0;
  list-style: none;
}
.clear:before {
  display: table;
  content: "";
  clear: both;
}
.clear:after {
  display: table;
  content: "";
  clear: both;
}
.left {
  float: left;
}
.right {
  float: right;
}
/* 弹出 */
.el-popup-parent--hidden {
  overflow: auto !important;
}
.el-dialog__header {
  background-color: #0d394a!important;
}
.el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.el-dialog__footer {
  padding-bottom: 40px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  text-align:center!important;
}

.el-dialog__body {
  padding: 10px 30px;
}
.el-form-item__label {
  font-size: 16px;
  color: #3A3A3A;
  font-family:'SourceHanSansMedium';
  font-weight: 500;
  padding: 0px !important;
}
.el-form-item {
  margin-bottom: 12px;
}
:root {
  --swiper-theme-color: #DB282C !important;
}
.work .el-button--primary,.mwork .el-button--primary{
  background: #DB282C!important;
  border: none !important;
}
.jobe .el-form-item__content{
  width:100%!important;
}
.jobe .el-button,.mjobe .el-button{
  width:100%!important;
  background:#DB282C!important;
  border:none!important;
}
.qd {
  height: 26px;
  line-height: 26px;
  width: 110px!important;
  border-radius: 0px;
  border: none !important;
  background-color: #0d394a!important;
  padding: 0px !important;
  margin:0 auto!important;
  border-radius:5px!important;
}
.qd:hover {
  background-color: #0d394a!important;
}
</style>





// WEBPACK FOOTER //
// src/App.vue